import { render, staticRenderFns } from "./roleMgt.vue?vue&type=template&id=33104638&"
import script from "./roleMgt.vue?vue&type=script&lang=js&"
export * from "./roleMgt.vue?vue&type=script&lang=js&"
import style0 from "./roleMgt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports